import { createColumnDate, createColumnInput, createColumnInputNumber, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";
import { callCertificateRequestStatus } from "../../../certificate/certificate-request/certificate-request.logic";
import { callTransportMode } from "../../../certificate/certificate-request/certificate-request.section";
import { callCountry } from "../../../master-mgt/country/country.logic";
import { callDepartment } from "../../../master-mgt/department-responsible/department-responsible.logic";

export const createColumns = ({ props }) => {
    let defaultCompanyDepartment = null;
    if (!has({ menuContext: props?.menuContext, key: "canSearchByCompanyDepartment" })) {
        defaultCompanyDepartment =
            store.state.resource.auth.info?.user?.refDepartment?.refParent || store.state.resource.auth.info?.user?.refDepartment;
    }
    const columns = [
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.requestDate"),
            dataIndex: "requestDate"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.requestNo"),
            dataIndex: "requestNo",
            align: "center",
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.company.thNo"),
            dataIndex: "refCompany.thNo",
            align: "center",
            width: 100
        }),
        createColumnInput({ title: () => i18n.global.t("model.company.nameTh"), dataIndex: "refCompany.nameTh" }),
        createColumnSelect({
            title: () => i18n.global.t("model.company.refDepartment"),
            dataIndex: "refCompany.refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: {
                visible: () => has({ menuContext: props?.menuContext, key: "canSearchByCompanyDepartment" }),
                name: "refCompany.refDepartment.id",
                field: { searchValue: defaultCompanyDepartment }
            },
            width: 120
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.certificateRequest.refExportCountry"),
            dataIndex: "refExportCountry.nameEn",
            inputProp: () => ({ list: callCountry, optLabel: "nameEn" }),
            search: { name: "refExportCountry.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.certificateRequest.refTransportMode"),
            dataIndex: "refTransportMode.value",
            inputProp: () => ({ list: callTransportMode, optLabel: "value" }),
            search: { name: "refTransportMode.id" }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.certificateApprovalDate"),
            dataIndex: "certificateApprovalDate"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.shipmentDate"),
            dataIndex: "shipmentDate"
        }),
        /*
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.hologramNo") + " 1",
            dataIndex: "hologramNo1",
            align: "center",
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.hologramNo") + " 2",
            dataIndex: "hologramNo2",
            align: "center",
            width: 100
        }),
        */
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.certificateNo"),
            dataIndex: "certificateNo",
            align: "center",
            width: 180
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.commodityName"),
            dataIndex: "commodityName"
        }),
        // createColumnSelect({
        //     title: () => i18n.global.t("model.aquaticScientificName.scientificName"),
        //     dataIndex: "aquaticScientificNames.id",
        //     dataIndexValue: ({ record }) => record.aquaticScientificNames.map(d => d.scientificName).join(", "),
        //     customRender: ({ record, column }) => column.dataIndexValue({ record }),
        //     inputProp: () => ({ list: () => [], optLabel: "scientificName" }),
        //     search: {
        //     visible: () => false,
        //         name: "aquaticScientificNames.id"
        //     }
        // }),
        //
        createColumnSelect({
            title: () => i18n.global.t("model.aquaticScientificName.scientificName"),
            dataIndex: "aquaticScientificNames.id",
            dataIndexValue: ({ record }) => record.aquaticScientificNames.map(d => d.scientificName).join(", "),
            customRender: ({ record, column }) => <div class="ql-container ql-snow disabled">
                <div class="ql-editor" innerHTML={column.dataIndexValue({ record })}></div>
            </div>,
            search: {
                visible: () => false,
                name: "aquaticScientificNames.id"
            },
            align: 'center',
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.samplingProduct.samplingNo") + '/' + i18n.global.t("model.certificateRequest.labels.packaging"),
            dataIndex: "certificateProducts.id",
            dataIndexValue: ({ record }) =>
                record.certificateProducts
                    .map(d =>
                        [
                            d.refSamplingProduct?.samplingNo,
                            d.refSamplingProduct?.packageSize,
                            [d.refSamplingProduct?.exportAmount, d.refSamplingProduct?.refExportAmountUnit?.value].filter(d2 => d2).join(" ")
                        ]
                            .filter(d => d?.length > 0)
                            .join(" ")
                    )
                    .join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: () => [], optLabel: "scientificName" }),
            search: {
                visible: () => false,
                name: "certificateProducts.id"
            }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.certificateRequest.qty"),
            dataIndex: "qty",
            allowPrecision: true,
            maxPrecision: 3,
            autoPrecision: false,
            inputProp: () => ({ allowPrecision: true, maxPrecision: 3, autoPrecision: false }),
            width: 100
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.certificateRequest.netWeight"),
            dataIndex: "netWeight",
            allowPrecision: true,
            maxPrecision: 3,
            autoPrecision: false,
            inputProp: () => ({ allowPrecision: true, maxPrecision: 3, autoPrecision: false }),
            width: 100
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.certificateRequest.grossWeight"),
            dataIndex: "grossWeight",
            allowPrecision: true,
            maxPrecision: 3,
            autoPrecision: false,
            inputProp: () => ({ allowPrecision: true, maxPrecision: 3, autoPrecision: false }),
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.productCodeNo"),
            dataIndex: "productCodeNo"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.certificateRequest.refRequestStatus"),
            dataIndex: "refRequestStatus.value",
            inputProp: () => ({ list: callCertificateRequestStatus, optLabel: "value" }),
            search: { name: "refRequestStatus.id" }
        })
    ];
    return columns;
};
